import { render } from "./Prs.vue?vue&type=template&id=78cc64f0&scoped=true"
import script from "./Prs.vue?vue&type=script&lang=js"
export * from "./Prs.vue?vue&type=script&lang=js"

import "./Prs.vue?vue&type=style&index=0&id=78cc64f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cc64f0"]])

export default __exports__